import React from "react";
import './App.css';
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import PuppelshowSection from "./components/PuppelshowSection";
import AboutSection from "./components/AboutSection";
import ContactSection from "./components/ContactSection";

const App = () => {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <PuppelshowSection />
        <AboutSection />
        <ContactSection />
      </main>
    </>
  );
};

export default App;
